export class ListViewModel<T> {
	data: T[] = [];
	total: number;
}